import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className'

// Replaces 'Mui' prefix with 'OSUI-' in MUI5 class names to avoid conflicts with MUI4
// Auto-configure when imported as side-effect (used internally by opensolar-ui/src/index.ts)
ClassNameGenerator.configure((componentName) => componentName.replace('Mui', 'OSUI-'))
